module.exports = __webpack_public_path__ + "assets/img/how-to-donate-payments.ec7159f9.png";